import { makeStyles } from "@mui/styles";
import { APP_THEMES, DEFAULT_THEME } from "./reducers/Theme/constants";

const [lightTheme, darkTheme, yellowTheme] = APP_THEMES;

const COMMOM_THEME_CONFIGS = {
  typography: {
    h1: {
      fontSize: 28,
      fontWeight: 300,
    },
    h2: {
      fontSize: 26,
      fontWeight: 300,
    },
    h3: {
      fontSize: 24,
      fontWeight: 400,
    },
    h4: {
      fontSize: 22,
      fontWeight: 400,
    },
    h5: {
      fontSize: 20,
      fontWeight: 400,
    },
    h6: {
      fontSize: 18,
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: 14,
      fontWeight: 500,
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
    },
    button: {
      fontSize: 14,
      fontWeight: 500,
    },
    caption: {
      fontSize: 12,
      fontWeight: 400,
    },
    overline: {
      fontSize: 10,
      fontWeight: 400,
    },
  },
};

export const THEME_CONFIGS = {
  [lightTheme]: {
    palette: {
      type: "light",
      primary: {
        main: "#0094FF",
        contrastText: "#fff",
        light: "rgba(0, 148, 255, 0.2)",
      },
      secondary: {
        main: "#5C5E63",
        dark: "#f5f5f5",
        stepColor: "#fff",
        stepBorderColor: "#e8e8e8",
        light: "rgba(255,255,255,0.12)",
        contrastText: "#fff",
        processTable: "#E9E9E9",
        sidebar: "#f1f1f1",
        textHoverBg: "#f5f5f5",
        modelTab: "rgba(0,0,0,0.06)",
      },
      text: {
        secondary: "#000",
      },
    },
    typography: { ...COMMOM_THEME_CONFIGS.typography },
    snackBar: {
      backgroundColor: "rgb(49, 49, 49) !important",
      color: "#fff !important",
    },
    relationshipMap: {
      portText: "rgba(0, 0, 0, 0.8)",
      nodeBackground: "#fff",
      portInColor: "#0094FF",
      titleColor: "rgba(0, 0, 0, 0.6)",
      border: "#ccc",
    },
    drawerBackground: "#f1f1f1",
  },
  [darkTheme]: {
    palette: {
      type: "dark",
      primary: {
        main: "#00B398",
        contrastText: "#fff",
        light: "rgba(0, 179, 152, 0.2)",
      },
      secondary: {
        main: "#292929",
        dark: "#1e1e1e",
        stepBorderColor: "#3b3b3b",
        stepColor: "#242424",
        light: "rgba(255,255,255,0.12)",
        contrastText: "#fff",
        processTable: "#191919",
        sidebar: "rgba(0,0,0,0.17)",
        textHoverBg: "rgb(15, 15, 15, 0.75)",
        modelTab: "rgba(255,255,255,0.12)",
      },
    },
    typography: { ...COMMOM_THEME_CONFIGS.typography },
    snackBar: {
      backgroundColor: "#fff !important",
      color: "rgb(49, 49, 49) !important",
    },
    relationshipMap: {
      portText: "rgba(255, 255, 255, 0.8)",
      nodeBackground: "#242424",
      portInColor: "#00B398",
      titleColor: "rgba(255, 255, 255, 0.6)",
      border: "rgb(59, 59, 59)",
    },
    drawerBackground: "#424242",
  },
  [yellowTheme]: {
    palette: {
      type: "dark",
      primary: {
        main: "#FFC001",
        contrastText: "#000",
        light: "rgba(255, 192, 1, 0.2)",
      },
      secondary: {
        main: "#292929",
        dark: "rgba(0, 0, 0, 0.17)",
        stepBorderColor: "#36383C",
        stepColor: "#1A1C21",
        light: "rgba(255,255,255,0.12)",
        contrastText: "#fff",
        processTable: "rgb(32, 32, 37)",
        sidebar: "rgba(0,0,0,0.17)",
        textHoverBg: "rgb(32, 32, 37)",
        modelTab: "rgba(255,255,255,0.12)",
      },
    },
    typography: { ...COMMOM_THEME_CONFIGS.typography },
    snackBar: {
      backgroundColor: "#FFC001 !important",
      color: "#000 !important",
    },
    relationshipMap: {
      portText: "rgba(255, 255, 255, 0.8)",
      nodeBackground: "#242424",
      portInColor: "#FFC001",
      titleColor: "rgba(255, 255, 255, 0.6)",
      border: "rgb(59, 59, 59)",
    },
    drawerBackground: "#25262c",
  },
};

/**
 * Get Theme Configs
 *
 * @param {Object}
 *
 * @return {Object}
 */
export const getThemeConfigs = ({ theme }) => {
  // if (!isAuthenticated) {
  //   return THEME_CONFIGS[lightTheme];
  // }

  return THEME_CONFIGS[theme];
};

export const snackBarStyles = (theme) => {
  if (!APP_THEMES.includes(theme)) theme = DEFAULT_THEME;

  return makeStyles({
    success: THEME_CONFIGS[theme || lightTheme].snackBar,
    error: THEME_CONFIGS[theme || lightTheme].snackBar,
    warning: THEME_CONFIGS[theme || lightTheme].snackBar,
    info: THEME_CONFIGS[theme || lightTheme].snackBar,
  });
};
